import React, { useEffect, useState } from "react";
import Button from "../../components/Form/Button";
import Modal from "../../components/Elements/Modal";
import RadioGroup from "../../components/Form/RadioGroup";
import {setTitle} from '../../helpers/MetaTag';
import AddTakeOffTime from "../../components/Modals/AddTakeOffTime";
import TakeOffTimeItem from "../../components/Items/TakeOffTimeItem";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { detailsTakeOff, listTakeOff, ordering } from "../../helpers/api_helper";
import Pagination from "../../components/Elements/Pagination";
import moment from "moment/moment";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { NoData } from "../../components/Elements/NoData";
import { Error } from "../../components/Elements/Error";
import { Loading } from "../../components/Elements/Loading";
import { toast } from "react-toastify";
import Select from "react-select";

const TakeOffTime = () => {
  setTitle('Dabbawala | Take Off Time');

  const queryClient = useQueryClient();

  const [statusStatic, setStatusStatic] = useState([
    { _id: "", name: "All", color: "success", current: true },
    { _id: true, name: "Published", color: "success", current: false },
    { _id: false, name: "Draft", color: "warning", current: false },
  ]);


  
  const [perPages] = useState([
    { label:"10 (Default)",value:10 },
    { label:20,value:20 },
    { label:50,value:50 },
    { label:100,value:100 },
    { label:"All",value:999999  },
 ]);

  const [dataList, setDataList] = useState([]);

  const [isOne, setDataOne] = useState(false);


  const [isAddModal, setIsAddModal] = useState(false);
  const [isEditModal, setIsEditModal] = useState(false);

  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [status, setStatus] = useState("");
  const [editId, setEditId] = useState("");
  const [selectedPageOpt, setSelectedPageOpt] = useState([]);



  const addModal = () => {
    setIsAddModal(true);
  };

  const queryTake = ["take_off_time", status, limit, offset];


  // For fetching details of item
  const {
    data: details,
    refetch,
    isFetching,
  } = useQuery({
    queryKey: ["details", editId],
    queryFn: async () => detailsTakeOff({ id: editId }),
    enabled: false,
  });

  // Refetch when editId updates
  useEffect(() => {
    if (editId !== "" && isEditModal) {
      refetch();
    }
  }, [editId, refetch, isEditModal]);

  // Diet List Component
  function TakeOffList() {
    // Custom hook for fetching diet list
    function useTakeOff() {
      return useQuery({
        queryKey: queryTake,
        queryFn: () =>
          listTakeOff({
            sortByField: "ordering",
            sortByValue: 1,
            status: status,
            limit: limit,
            offset: offset,
          }),
        keepPreviousData: true,
      });
    }

    const { data: takOff, error, isFetching } = useTakeOff();

    useEffect(() => {
      if (!isOne) {
        setDataList(takOff?.data);
      }
    }, [takOff?.data]);

    const handleDragEnd = (e) => {
      //console.log(e);
      if (!e.destination) return;
      let tempData = Array.from(dataList);
      let [source_data] = tempData.splice(e.source.index, 1);
      tempData.splice(e.destination.index, 0, source_data);
      // console.log(tempData);
      setDataList([...tempData]);
      let dataArray = [];
      for (let i = 0; i < tempData.length; i++) {
        dataArray.push({ id: tempData[i]._id, ordering: i + 1 });
      }
      // setOrderingData(dataArray);
      onClickSaveOrdering(dataArray);
      setDataOne(true);
    };
    const onClickSaveOrdering = async (orderingData) => {
      const saveOrdering = await ordering({
        orderingData: orderingData,
        tableName: "take_of_time",
      });

      if (saveOrdering.status === 200) {
        setDataOne(false);
        queryClient.invalidateQueries(queryTake);
        queryClient.removeQueries({
          queryKey: ["take_off_time"],
          type: "inactive",
        });
        toast.success(saveOrdering.message);
      } else {
        toast.error(saveOrdering.message);
      }
    };

    // Handling loading state 😑
    if (isFetching) {
      return <Loading />
    }

    // Handling error state 🥴
    if (error) {
      return <Error />
    }

    // Check if their is no data 🤨
    else if (takOff.data.length === 0) {
      return <NoData /> 
    }

    // Renders the list
    else {
      return (
        // For Pagination
        <>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="droppable">
              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {dataList &&
                    dataList.length > 0 &&
                    dataList.map((item, index) => (
                      <TakeOffTimeItem
                        key={item._id}
                        id={item._id}
                        name={item.time}
                        createdBy={item.createdBy}
                        status={item.status}
                        index={index}
                        createdDate={moment(new Date(item?.created_at)).format(
                          "Do MMM YY"
                        )}
                        updatedDate={moment(new Date(item?.updated_at)).format(
                          "Do MMM YY"
                        )}
                        query={queryTake}
                        setEditId={setEditId}
                        setEditModal={setIsEditModal}
                      />
                    ))}

                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <Pagination count={takOff.count} limit={limit} offset={offset} setOffset={setOffset} />
        </>
      );
    }
  }
  return (
    <>
      
        <div className="page-filter mb-3">
          <div className="input-filters d-flex justify-content-between">
            <div className="input-items">
            <Select
                  className="select-tag"
                  isMulti={false}
                  isClearable={true}
                  options={perPages}
                  value={selectedPageOpt || []}
                  placeholder={'Per Page'}
                  onChange={(e) => {
                    setLimit(e.value);
                    setSelectedPageOpt(e);
                  }}
                 />
            </div>

            <div className="input-items items-end gap-3 ms-auto">


              <Button label={""} labelClasses={""} classes={"px-2"} icon={"fa-regular fa-arrow-rotate-right"} iconPosition={"left"} 
              functions={() => {
                queryClient.invalidateQueries(queryTake);
                queryClient.removeQueries({
                  queryKey: ["take_off_time"],
                  type: "inactive",
                });
                setOffset(0);
                setStatus("");
                setStatusStatic([]);
                setTimeout(() => {
                  setStatusStatic([
                    { _id: "", name: "All", color: "success", current: true },
                    {
                      _id: true,
                      name: "Published",
                      color: "success",
                      current: false,
                    },
                    {
                      _id: false,
                      name: "Draft",
                      color: "warning",
                      current: false,
                    },
                  ]);
                }, 300);
              }}
              />
              <Button label={"Take Off Time"} labelClasses={""} classes={""} icon={"fa-regular fa-plus"} iconPosition={"left"} functions={addModal} />
            </div>
          </div>
          <div className="radio-filters">
            <RadioGroup data={statusStatic} setData={setStatus} inputName={"status"} />
          </div>
        </div>
        <div className="take-off-list">
          <TakeOffList />
        </div>
     
      <Modal title={"Add Take Off Time"} size={"sm"} isOpen={isAddModal} modalClose={() => setIsAddModal(!isAddModal)}>
        <AddTakeOffTime />
      </Modal>

      
      {/* // For add Modal */}
      <Modal
        title={"Add Take Off Time"}
        size={"sm"}
        isOpen={isAddModal}
        modalClose={() => setIsAddModal(false)}
      >
        <AddTakeOffTime modalClose={() => setIsAddModal(false)} query={queryTake} />
      </Modal>

      {/* //For Edit Modal */}
      <Modal
        title={"Edit Take Off Time"}
        size={"sm"}
        isOpen={isEditModal}
        modalClose={() => setIsEditModal(false)}
      >
        <AddTakeOffTime
          modalClose={() => setIsEditModal(false)}
          query={queryTake}
          details={details}
          isFetching={isFetching}
        />
      </Modal>

    </>
  );
};

export default TakeOffTime;
